import React from 'react';
import PropTypes from 'prop-types';

function ToggleSwitch({ toggle, setToggle }) {
  const handleToggle = () => {
    setToggle(!toggle);
  };

  return (
    <button type="button" className="flex items-center" onClick={handleToggle}>
      <div
        className="relative p-[4px] w-[60px] h-[36px] border border-[lightgray] bg-[#F1F5F9] rounded-[30px] transition-colors duration-300"
        style={{
          background: toggle ? '#773DBD' : '#F1F5F9',
        }}
      >
        <div
          className="absolute top-[50%] w-[24px] h-[24px] flex justify-center items-center rounded-[50%] border font-[700] text-[11px] transition-all duration-300"
          style={{
            transform: 'translateY(-50%)',
            left: toggle ? 'calc(100% - 28px)' : '4px', // Adjusting based on the size and padding
            background: toggle ? '#fff' : '#A9B6CA',
            color: toggle ? '#773DBD' : '#383C4B',
            borderColor: toggle ? '#fff' : '#A9B6CA',
          }}
        >
          {toggle ? 'on' : 'off'}
        </div>
      </div>
    </button>
  );
}

ToggleSwitch.propTypes = {
  toggle: PropTypes.bool.isRequired,
  setToggle: PropTypes.func.isRequired,
};

export default ToggleSwitch;
